<section class="component-popup-header">
  <img *ngIf="showImage" class="component-header-image" src="/img/avatar/header-image.svg" alt="header-image">
  <!-- <img class="component-headerbox-image" src="/img/avatar/headerBox.svg"> -->
  <div class="popupHeaderCaption" [ngClass]="{blue: color==='blue'}"><span>{{caption}}</span></div>
</section>
